'use client';

import { cn } from '@wolfejs/ui/utils/classnames';
import { routes } from 'apps/portals/src/routes';
import type { ProductGridType } from './types';

const ProductGrid = ({ products, params }: ProductGridType) => {
  const { portalSlug: slug } = params;
  // NOT possible to know from the listBrands data. But maybe implement in future?
  // const hasDigitalProduct = (variants: PGCorpProductVariant[]) =>
  //   variants.some(variant => variant.metadata.type === 'digital');
  // const hasPhysicalProduct = (variants: PGCorpProductVariant[]) =>
  //   variants.some(variant => variant.metadata.type === 'physical');

  return (
    <div className={cn('@container @md:grid-cols-4 @lg:grid-cols-4 @2xl:grid-cols-6 grid grid-cols-2 gap-4')}>
      {products.map(product => (
        <a
          href={`/${slug}${routes.products}/${product.uuid}`}
          key={product.uuid}
          className="border-default-300 mb-2 min-w-[110px] max-w-[225px] rounded-lg border bg-white p-3 hover:drop-shadow-lg"
        >
          <img
            className="mb-3 max-h-[120px] w-full overflow-hidden rounded-lg"
            src={product.image || 'https://placehold.co/300x190'}
            alt={product.name}
            onError={e => {
              // Fallback to placeholder image
              e.currentTarget.onerror = null; // Prevent infinite loop if fallback fails
              e.currentTarget.src =
                'https://d3lh2hqqgsec27.cloudfront.net/merchant-images/lg/default-perfectgift-card.png';
            }}
          />
          <div className="mb-3">
            <h2 className="text-lg font-semibold text-black">{product.name}</h2>
          </div>
          {/* <div className=" @lg:gap-2 flex flex-wrap gap-1">
            {hasPhysicalProduct(product.variants) && (
              <Link
                className="text-primary @md:text-xs @2xl:text-base hover:bg-primary inline-block rounded-md border bg-white px-2 py-1 font-bold hover:text-white"
                href={{
                  pathname: `/${slug}${routes.products}/${product.id}`,
                  query: { type: 'physical' },
                }}
              >
                Plastic
              </Link>
            )}
            {hasDigitalProduct(product.variants) && (
              <Link
                className="text-primary @md:text-xs @2xl:text-base hover:bg-primary inline-block rounded-md border bg-white px-2 py-1 font-bold hover:text-white"
                href={{
                  pathname: `/${slug}${routes.products}/${product.id}`,
                  query: { type: 'digital' },
                }}
              >
                Digital
              </Link>
            )}
          </div> */}
        </a>
      ))}
    </div>
  );
};
export default ProductGrid;
